import { Component } from '@grafikr/components';
import Cookie from 'js-cookie';

import clear from 'utils/clear';
import Modal from 'utils/components/modal';
import { NonNullish } from 'utils/nullish-check';

type Country = {
  country: string;
  country_3: string;
  ip: string;
  name: string;
};

export default Component((node, { onMounted }) => {
  const modal = new Modal(node);
  const select = NonNullish(node.querySelector<HTMLSelectElement>('[data-select]'));
  const form = NonNullish(node.querySelector('form'));

  const initCountryPicker = () => {
    const icon = node.querySelector<HTMLElement>('[data-icon]')!;

    window.theme.languages.forEach((language) => {
      if (language.locale === Shopify.locale) return;

      select.insertAdjacentHTML(
        'beforeend',
        `<option value="${language.locale}">${language.name} / ${language.currency}</option>`,
      );
    });

    select.addEventListener('change', () => {
      const template = node.querySelector<HTMLTemplateElement>(
        `template[data-locale="${select.value}"]`,
      )!;

      if (template) {
        const clone = template.content.cloneNode(true);

        clear(icon);
        icon.appendChild(clone);
      }
    });
  };

  const submitHandler = (event: SubmitEvent) => {
    event.preventDefault();

    const selectedLanguage = window.theme.languages.find(
      (language) => language.locale === select.value,
    )!;

    if (selectedLanguage.locale === Shopify.locale) {
      modal.close();
      return;
    }

    window.location.href = selectedLanguage.domain;
  };

  const setPreferredLanguage = (data: Country) => {
    const fallback = window.theme.languages.find((language) => language.fallback);
    const findMatch =
      window.theme.languages.find((language) => language.locale === data.country) ?? fallback;

    if (findMatch) {
      const optionIndex = Array.from(select.options).findIndex(
        (option) => option.value === findMatch.locale,
      );
      select.selectedIndex = optionIndex;

      select.dispatchEvent(new Event('change'));
    }
  };

  const initModal = () => {
    initCountryPicker();
    form.addEventListener('submit', submitHandler);

    modal.open();
  };

  const init = async () => {
    if (Cookie.get('geo')) {
      return;
    }

    const response = await fetch('https://get.geojs.io/v1/ip/country.json');

    if (response.ok) {
      const data: Country = await response.json();
      Cookie.set('geo', 'true');

      if (data.country !== Shopify.country) {
        initModal();
        setPreferredLanguage(data);
      }
    }
  };

  onMounted(() => {
    init();
  });
});
